<template>
  <el-dialog
    class="rc-dialog-column"
    :class="{ 'list-drag': dragaable }"
    title="栏目管理"
    :visible.sync="dialogVisible"
    width="50%"
    top="20vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    @close="close"
  >
    <div class="filter_container">
      <butn
        btntype="primary"
        title="新增"
        iconName="el-icon-plus"
        v-permission="'periodicalSubject:save'"
        @click.native="handleAdd"
      ></butn>
      <el-checkbox :disabled="dragDisabled" v-model="dragaable" class="drag-box"
        >拖拽排序</el-checkbox
      >
    </div>

    <Table @selection-change="selectionChange" row-key="uuid" :data="list" />
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Table from "./table.js";
import {
  subjectList,
  subjectDelete,
  subjectOrderByDrag
} from "@/api/periodicalSubject";
import Bus from "../Bus.js";
import { Message } from "element-ui";
import Sortable from "sortablejs";
export default {
  components: { butn, Table },
  data() {
    return {
      dialogVisible: false,
      list: [],
      api: subjectList,
      checkArray: [],
      dragaable: false,
      periodicalId: "",
      sort: null
    };
  },
  created() {
    var _this = this;
    Bus.$on("columnManage", id => {
      this.dialogVisible = true;
      this.periodicalId = id;
      this.getData();
    });
    Bus.$on("deleteSubject", function(item) {
      _this.deleteSubject(item);
    });
    Bus.$on("reload", function() {
      _this.getData();
    });
  },
  beforeDestroy() {
    Bus.$off("columnManage");
    Bus.$off("deleteSubject");
    Bus.$off("reload");
  },
  computed: {
    dragDisabled() {
      if (this.list.length < 2) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dragaable = false;
        return true;
      }
      return false;
    }
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    }
  },
  mounted() {
    this.resetData();
  },
  methods: {
    resetData() {
      this.getData();
    },
    close() {
      this.dragaable = false;
    },
    //拖拽
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(
          ".rc-dialog-column .el-table__body-wrapper tbody"
        );
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          onEnd({ oldIndex, newIndex }) {
            if (oldIndex === newIndex) return;
            const currRow = _this.list[oldIndex];
            let offset = newIndex - oldIndex;
            let params = {
              offset: offset,
              periodicalSubject: currRow
            };
            subjectOrderByDrag(params).then(res => {
              if (!res || res.code != 0) return;
              Message({
                message: "排序成功",
                type: "success"
              });
              const currR = _this.list.splice(oldIndex, 1)[0];
              _this.list.splice(newIndex, 0, currR);
            });
          }
        });
      }
    },
    handleAdd() {
      Bus.$emit("addSubject", this.periodicalId);
    },
    selectionChange: function(selections) {
      this.selections = selections;
    },
    getData() {
      let id = this.periodicalId;
      if (id == null || id == "") {
        return;
      }
      subjectList(id).then(res => {
        if (!res || res.code != 0) return;
        this.list = res.data;
      });
    },
    deleteSubject(data) {
      this.$confirm(`确认要删除该栏目吗?`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.loading = true;
        subjectDelete({ uuids: [data.uuid] })
          .then(res => {
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              // 带上历史条件更新列表
              this.resetData();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog-column {
  /deep/ .el-dialog__body {
    max-height: 500px;
  }
  .left {
    margin-left: 10px;
  }
  /deep/ .el-input {
    width: 50%;
  }
  /deep/ .drag-box {
    float: right;
    margin-top: 15px;
    .el-checkbox__label {
      font-size: 12px;
      color: #51627d;
      font-weight: normal;
    }
  }
}
</style>
